import React, { useState, useEffect } from "react";
import { Ban, Inbox, UploadCloud } from "lucide-react";
import { useParams } from "react-router-dom";
import { driveFolderId, subjects } from "../../constants";
import { useUser } from "../../UserContext";
import axios from "axios";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners"; // Import ClipLoader from react-spinners
import { db } from "../../firebase";
import { onValue, push, ref, set } from "firebase/database";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Manila");

const Classes = ({ expanded }) => {
  let { id } = useParams();
  const { user } = useUser();

  const [file, setFile] = useState(null);
  const [attendances, setAttendances] = useState([]);
  const [attendancesObject, setAttendancesObject] = useState({});
  const [activeTab, setActiveTab] = useState("attendance");
  const [imageUrl, setImageUrl] = useState(null); // State to hold temporary URL of selected image
  const [loading, setLoading] = useState(false); // Loading state
  const [isAttendance, setIsAttendance] = useState(false);
  const [todayAttendance, setTodayAttendance] = useState(null);

  const filteredAttendances = attendances.filter(
    (x) => x.studentNumber === user.studentNumber
  );

  useEffect(() => {
    const query = ref(db, `subjects/${id}`);

    const unsubscribeValue = onValue(query, (snapshot) => {
      const data = snapshot.val();
      if (snapshot.exists()) {
        setAttendancesObject(data);
        setAttendances(Object.values(data));
      } else {
        setAttendancesObject({});
        setAttendances([]);
      }
    });

    return () => {
      setFile(null);
      setAttendances([]);
      setAttendancesObject({});
      setActiveTab("attendance");
      setTodayAttendance(null);
      setImageUrl(null);
      setLoading(false);
      setIsAttendance(false);
      unsubscribeValue();
    };
  }, [user, id]);

  useEffect(() => {
    const checkAttendance = async () => {
      try {
        const timeResponse = await axios.get(
          "https://worldtimeapi.org/api/timezone/Asia/Manila"
        );
        const currentTime = moment(timeResponse.data.datetime);
        let todayAttendance = null;

        for (const [key, attendance] of Object.entries(attendancesObject)) {
          const attendanceTime = moment(attendance.timestamp);
          if (
            attendanceTime.isSame(currentTime, "day") &&
            attendance.studentNumber === user.studentNumber
          ) {
            if (attendance.hasOwnProperty("out")) {
              setIsAttendance(true);
            } else {
              setIsAttendance(false);
            }
            todayAttendance = key;
            break; // No need to continue once attendance is found
          }
        }

        setTodayAttendance(todayAttendance);
      } catch (error) {
        console.error("Error fetching attendance:", error);
        // Handle error
      }
    };

    checkAttendance();

    // eslint-disable-next-line
  }, [attendances]);

  const cardStyle = {
    backgroundImage: "url('https://pinnacle.pnc.edu.ph/img/pnc-bg.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    // backgroundColor: "#198754",
    position: "relative",
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);

    if (selectedFile) {
      // Create temporary URL for selected image
      setImageUrl(URL.createObjectURL(selectedFile));
    } else {
      setImageUrl(null);
    }
  };

  const handleFileUpload = async () => {
    if (!file) {
      alert("Please select a file.");
      return;
    }

    setLoading(true); // Set loading to true while uploading

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("folderName", user.studentNumber);
      formData.append("parentFolderId", driveFolderId[id]);

      const response = await axios.post(
        "https://class-trackr-server.onrender.com/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        const time = await axios.get(
          "https://worldtimeapi.org/api/timezone/Asia/Manila"
        );
        const timeGMT8 = moment(time.data.datetime).format(
          "YYYY-MM-DD HH:mm:ss"
        );

        const data = {
          studentNumber: user.studentNumber,
          studentName: user.name,
          section: user.section,
          imageId: response.data.imageId,
          timestamp: timeGMT8,
        };

        console.log(data);
        console.log(time.data.datetime);

        if (todayAttendance !== null) {
          const query = ref(db, `subjects/${id}/${todayAttendance}/out`);
          await set(query, data);

          toast.success("Attendance Time Out successfully submitted!");
        } else {
          const query = ref(db, `subjects/${id}`);
          await push(query, data);

          toast.success("Attendance Time In successfully submitted!");
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error.message);
      toast.error("Error submitting your attendance! Try again.");
    } finally {
      setFile(null);
      setImageUrl(null);
      setLoading(false); // Set loading to false after upload completes
    }
  };

  return (
    <div className={`ml-0 mt-16  ${expanded ? "md:ml-[15.5rem]" : "md:ml-20"}`}>
      <div className="card w-full flex items-center justify-center pt-4 mb-4">
        <div
          className="p-5 relative w-11/12 rounded-sm max-w-6xl"
          style={cardStyle}
        >
          <div className="text-right px-4 pb-10 text-white">
            <i>Class #{parseInt(id) + 1}</i>
          </div>
          <h4 className="text-center mb-0 text-white text-2xl pb-16">
            <b>{subjects[id]}</b>
          </h4>
        </div>
      </div>
      <ul
        className="nav nav-tabs flex w-full items-center justify-center"
        id="nav-tab"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <button
            className={`button py-2 px-5 text-[#495057] bg-[#efefef] ${
              activeTab === "attendance" &&
              "bg-[#fff] border border-t-dee2e6 border-r-dee2e6 border-b-0"
            }  text-sm`}
            onClick={() => handleTabChange("attendance")}
            type="button"
          >
            <b>ATTENDANCE</b>
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`button py-2 px-5 text-[#495057] bg-[#efefef] ${
              activeTab === "submitAttendance" &&
              "bg-[#fff] border border-t-dee2e6 border-r-dee2e6 border-b-0"
            }  text-sm`}
            onClick={() => handleTabChange("submitAttendance")}
            type="button"
          >
            <b>SUBMIT ATTENDANCE</b>
          </button>
        </li>
      </ul>
      <hr className="mb-4 max-w-6xl w-11/12 mx-auto" />

      {/* Conditionally render components based on activeTab state */}
      {activeTab === "attendance" && (
        <>
          {filteredAttendances.length > 0 ? (
            <div className="mb-12">
              {filteredAttendances.map((x) => {
                const formattedDate = moment(x.timestamp).format(
                  "MMMM DD, YYYY"
                );
                return (
                  <div
                    key={x.imageId}
                    className="w-full flex items-center justify-center mb-3"
                  >
                    <div className="w-11/12 rounded-sm max-w-6xl bg-white py-4 px-4 shadow-md">
                      <div className="flex flex-row justify-between items-center py-2">
                        <div className="flex flex-col self-start">
                          <h4 className="font-semibold uppercase text-xl">
                            Attendance submitted
                          </h4>
                          <p className="text-gray-500 text-sm">
                            {formattedDate}
                          </p>
                        </div>
                        <div className="flex flex-row items-center gap-8">
                          <div>
                            <p className="text-gray-500 text-sm text-center">
                              TIME IN
                            </p>
                            <img
                              src={`https://drive.google.com/thumbnail?id=${x.imageId}`}
                              alt="Loading on server side. Please wait to load!"
                              className="w-28 h-28 object-scale-down"
                            />
                            <p className="text-gray-500 text-sm text-center">
                              {moment(x.timestamp).format("h:mm A")}
                            </p>
                          </div>

                          <div>
                            {x?.out ? (
                              <>
                                <p className="text-gray-500 text-sm text-center">
                                  TIME OUT
                                </p>
                                <img
                                  src={`https://drive.google.com/thumbnail?id=${x.out.imageId}`}
                                  alt="Loading on server side. Please wait to load!"
                                  className="w-28 h-28 object-scale-down"
                                />
                                <p className="text-gray-500 text-sm text-center">
                                  {moment(x.out.timestamp).format("h:mm A")}
                                </p>
                              </>
                            ) : (
                              <>
                                <p className="text-gray-500 text-sm text-center">
                                  TIME OUT
                                </p>
                                <p className="text-red-500 text-md text-center">
                                  N/A
                                </p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="w-full flex items-center justify-center mb-12">
              <div className="w-11/12 rounded-sm max-w-6xl bg-white py-6 shadow-md">
                <div className="flex flex-col items-center gap-2 py-4">
                  <Inbox size={64} />
                  <p className="">No Attendance Found</p>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {activeTab === "submitAttendance" && (
        <div className="w-full flex items-center justify-center mb-12">
          <div className="w-11/12 rounded-sm max-w-6xl bg-white py-6 shadow-md">
            <div className="flex flex-col items-center gap-4">
              <div className="flex items-center justify-center w-full">
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-10/12 h-48 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    {isAttendance ? (
                      <>
                        <Ban size={42} className="mb-2 text-red-400" />
                        <p className="mb-2 px-2 text-center text-sm font-semibold text-red-600">
                          You can only submit attendance once per day!
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="mb-2 text-sm font-semibold text-[#198754]">
                          {todayAttendance === null ? "TIME IN" : "TIME OUT"}
                        </p>
                        <UploadCloud size={42} className="mb-2" />
                        <p className="mb-2 text-sm">
                          <span className="font-semibold">Click to upload</span>{" "}
                          or drag and drop
                        </p>
                        <p className="text-xs">Images Files Only</p>
                      </>
                    )}
                  </div>
                  <input
                    id="dropzone-file"
                    type="file"
                    className="hidden"
                    accept="image/*"
                    onChange={handleFileChange}
                    disabled={isAttendance}
                  />
                </label>
              </div>

              {imageUrl && (
                <img
                  src={imageUrl}
                  alt="Selected"
                  className="w-32 h-32 object-scale-down"
                />
              )}

              {loading ? ( // Conditionally render loading spinner
                <ClipLoader color={"#198754"} loading={loading} size={35} />
              ) : (
                <button
                  onClick={handleFileUpload}
                  type="button"
                  disabled={isAttendance}
                  className="focus:outline-none text-white bg-[#198754] hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2 me-2"
                >
                  Submit Attendance
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Classes;
